import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import React from 'react'

interface ApplicationConfigContext {
  brand: Brand
  themeBrand: Brand
}

export const ApplicationConfigContext =
  React.createContext<ApplicationConfigContext>(null)
